var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWaveThird = function SvgWaveThird(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "waveThird_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 600,
    height: 272
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h600v272H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#waveThird_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1200 232.132V7.676H600V267.52c-354.821 36.061-416.407-157.39-902.1-157.39-332.426 0-506.687 108.184-717.34 124.361-95.28 7.317-157.7 5.617-180.56-2.359Z",
    fill: "#A3CD50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1200 224.456V0H600v259.844c-354.821 36.061-416.407-157.389-902.1-157.389-332.426 0-506.687 108.184-717.34 124.361-95.28 7.316-157.7 5.617-180.56-2.36Z",
    fill: "#0090DA"
  }))));
};
export default SvgWaveThird;